// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"04f1bd75","404":"ea3a4db5","498":"b0ac1d24"}[chunkId] + ".chunk.js";
};